/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Status_ServicesInputs */

const en_offline_status_services = /** @type {(inputs: Offline_Status_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Services`)
};

const fr_offline_status_services = /** @type {(inputs: Offline_Status_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Services`)
};

const de_offline_status_services = /** @type {(inputs: Offline_Status_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienstleistungen`)
};

const it_offline_status_services = /** @type {(inputs: Offline_Status_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servizi`)
};

const ru_offline_status_services = /** @type {(inputs: Offline_Status_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Услуги`)
};

const es_offline_status_services = /** @type {(inputs: Offline_Status_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicios`)
};

const zh_cn2_offline_status_services = /** @type {(inputs: Offline_Status_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务`)
};

const ja_offline_status_services = /** @type {(inputs: Offline_Status_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サービス`)
};

const hi_offline_status_services = /** @type {(inputs: Offline_Status_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेवाएं`)
};

const pt_pt2_offline_status_services = /** @type {(inputs: Offline_Status_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serviços`)
};

/**
* | output |
* | --- |
* | "Services" |
*
* @param {Offline_Status_ServicesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_status_services = /** @type {((inputs?: Offline_Status_ServicesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Status_ServicesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_status_services(inputs)
	if (locale === "de") return de_offline_status_services(inputs)
	if (locale === "it") return it_offline_status_services(inputs)
	if (locale === "ru") return ru_offline_status_services(inputs)
	if (locale === "es") return es_offline_status_services(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_status_services(inputs)
	if (locale === "ja") return ja_offline_status_services(inputs)
	if (locale === "hi") return hi_offline_status_services(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_status_services(inputs)
	return en_offline_status_services(inputs)
});